export enum TemplateTabsKey {
  Build,
  General,
  Schedule,
  Identifiers,
  Users,
  Leads,
}
